import fetch from "@/uilts/request";


// 深圳风控报告
export default {
    /**
     * 创建授权书
     */
    createSingContract(data) {
        return fetch.post("ZuWu/createSingContract", data)
    },

    /**
     * 获取风控结果
     */

    queryZuWu(data) {
        return fetch.post("ZuWu/queryZuWu", data)
    },

    
    getFileDownload(data) {
        return fetch.post("ZuWu/getFileDownload", data)
    }


}
